import {
  competenciesMockup,
  complianceAssistantMockup,
  complianceAssistantMockupC,
  documentsMockup,
  fillableDocumentsMockup,
  loggingMockup,
  policiesMockup,
  standardsMockup,
  trackingMockup,
} from '@surglogs-app/images'

import { PromoModalFeature } from '../types'

type FeatureData = {
  image: string
  isInDevelopment?: boolean
  isNewFeature?: boolean
  withHeader?: boolean
  videoUrl?: string
}

export const FEATURES: Record<PromoModalFeature, FeatureData> = {
  DOCUMENTS: {
    image: documentsMockup,
    videoUrl:
      'https://s3.us-west-2.amazonaws.com/global.surglogs.com/videos/_Documents_Surglogs.mp4',
  },
  POLICIES: {
    image: policiesMockup,
    isInDevelopment: true,
    withHeader: true,
    videoUrl:
      'https://s3.us-west-2.amazonaws.com/global.surglogs.com/videos/_Policies_Surglogs.mp4',
  },
  STANDARDS: {
    image: standardsMockup,
    isInDevelopment: true,
    videoUrl:
      'https://s3.us-west-2.amazonaws.com/global.surglogs.com/videos/_Standards_Surglogs.mp4',
  },
  SURGICALLOGS: {
    image: loggingMockup,
  },
  TRACKING: {
    image: trackingMockup,
    videoUrl:
      'https://s3.us-west-2.amazonaws.com/global.surglogs.com/videos/_Tracking_Surglog.mp4',
  },
  FILLABLE_DOCUMENTS: {
    image: fillableDocumentsMockup,
    isNewFeature: true,
  },
  COMPETENCIES: {
    image: competenciesMockup,
    isNewFeature: true,
  },
  LOGIN_PROMO_VIDEO: { image: '' },
  SURVEY_READINESS_A: {
    image: complianceAssistantMockup,
    isInDevelopment: true,
    videoUrl:
      'https://s3.us-west-2.amazonaws.com/global.surglogs.com/videos/Compliance-Assistant.mp4',
  },
  SURVEY_READINESS_B: {
    image: complianceAssistantMockup,
    isInDevelopment: true,
    videoUrl:
      'https://s3.us-west-2.amazonaws.com/global.surglogs.com/videos/Compliance-Assistant.mp4',
  },
  SURVEY_READINESS_C: {
    image: complianceAssistantMockupC,
    isInDevelopment: true,
    videoUrl:
      'https://s3.us-west-2.amazonaws.com/global.surglogs.com/videos/Compliance-Assistant.mp4',
  },
}
